<template>
  <!-- Hero Section -->
  <section
    class="relative flex items-center justify-center bg-cover bg-center"
    :class="[isBig ? 'h-[70vh]' : 'h-[40vh]']"
    :style="{ backgroundImage: `url(/img/${bgImg})` }"
  >
    <div class="absolute inset-0 bg-black opacity-90"></div>
    <div class="relative z-10 text-center text-white max-w-2xl mx-auto">
      <h1 class="text-4xl md:text-5xl font-bold mb-4">
        {{ title }}
      </h1>
      <p class="text-lg md:text-xl mb-8">
        {{ subtitle }}
      </p>
      <div v-if="isBig" class="flex flex-col md:flex-row gap-4 justify-center">
        <router-link to="/planning" class="bg-primary hover:bg-primary-dark text-white font-bold py-3 px-8 rounded shadow-lg transition">
          Essai gratuit 30 jours
        </router-link>
        <router-link to="/pricing" class="bg-white text-primary font-bold py-3 px-8 rounded shadow-lg border border-primary hover:bg-primary hover:text-white transition">
          Voir les tarifs
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection',
  props: ['title', 'subtitle', 'isBig', 'bgImg']
}
</script>